<template>
  <div :class="[show_filters ? 'visible' : '']" class="filters aside__block">
    <div class="filters__header">
      <span v-if="!show_subcategory">Фильтры</span>
      <button
        @click="showFilters"
        class="
          button-v2 button-v2_transparent-3 button-v2_small
          filter-control-button
        "
      >
        <div class="button-v2__inner">
          <div class="button-v2__icon-box">
            <svg
              preserveAspectRatio="none"
              viewBox="0 0 24 24"
              fill="none"
              class="button-v2__icon"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 10.586L4.222 2.808 2.808 4.222 10.586 12l-7.778 7.778 1.414 1.414L12 13.414l7.778 7.778 1.414-1.414L13.414 12l7.778-7.778-1.414-1.414L12 10.586z"
              />
            </svg>
          </div>
        </div>
      </button>
    </div>

    <div v-if="show_subcategory" class="filters__body">
      <FilterByCategory />
      <!--      <FilterByPrice/>-->
      <FilterByPrice />
      <FilterByTypeList
        v-for="property in properties"
        :key="property.property_id"
        :property="property"
      />
    </div>

    <!--    <div class="filters__body">-->
    <!--      <FilterByPrice/>-->
    <!--      <FilterByTypeList v-for="property in properties" :key="property.property_id" :property="property"/>-->
    <!--    </div>-->

    <div v-if="show_subcategory" class="filters__footer"></div>

    <div v-if="!show_subcategory" class="filters__footer">
      <button
        @click="showFilters"
        class="
          button-v2 button-v2_colored-1 button-v2_small
          filter-control-button
        "
      >
        <div class="button-v2__inner">
          <div class="button-v2__label">Показать товары</div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FilterByCategory from "./Filters/BySubGroups";
import FilterByPrice from "./Filters/ByPrice";
import FilterByTypeList from "./Filters/ByTypeList";

export default {
  name: "GroupFiltersAndSubGroups",
  components: {
    FilterByCategory,
    FilterByPrice,
    FilterByTypeList,
  },
  updated() {
    if (this.show_filters) {
      this.ppJs.general.main.style.zIndex = "10";
      document.body.style.overflow = "hidden";
    } else {
      this.ppJs.general.main.style.zIndex = "";
      document.body.style.overflow = "";
    }
  },
  methods: {
    showFilters() {
      this.$store.commit("group_info/CHANGE_SHOW_FILTERS");
    },
  },
  computed: {
    ...mapGetters({
      show_filters: "group_info/GET_SHOW_FILTERS",
      show_subcategory: "group_info/GET_SHOW_SUBCATEGORY",
      properties: "group_info/GET_PROPERTIES",
    }),
  },
};
</script>
